<template>
  <div class="edit-sign-up-root sign-up-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="backComfim=true" class="nav-wrap">
        <p class="title">编辑高端培训报名</p>
        <div class="nav-right" slot="right"></div>
      </yioks-page-nav>
      <div class="content-wrap">
        <vue-scroll :ops="vuescrollOpt">
          <div class="form-wrap">
            <el-form
              :model="formData"
              :rules="formRules"
              ref="mainForm"
              label-width="190px"
              size="medium"
              class="form-cont"
            >
              <el-form-item label="培训班等级" prop="class_level" class>
                <el-select
                  v-model="formData.class_level"
                  disabled
                  class="input-w260"
                  placeholder="请选择培训班等级"
                >
                  <el-option
                    v-for="item in highClassLevelList"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="报名类型" prop="enroll_type" class>
                <el-select
                        v-model="enroll_type"
                        disabled
                        class="input-w260"
                        placeholder="请选择报名类型"
                >
                  <el-option
                          v-for="item in enroll_type_list"
                          :key="item.value"
                          :label="item.key"
                          :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="报名名称" prop="sign_name" class="test-inline">
                <el-button type="primary" @click="ifNameDiaShow=true">添加名称</el-button>
                <span class="text_line right">{{formData.sign_name}}</span>
              </el-form-item>

              <el-form-item label="报名日期" prop="trainRange">
                <el-date-picker
                  type="daterange"
                  :editable="false"
                  :clearable="false"

                  value-format="timestamp"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  v-model="formData.trainRange"
                  class="input-w360"
                ></el-date-picker>
              </el-form-item>
  
              <el-form-item label="计划开班“期数/月份”切换" prop="numLimit" class>
                <el-switch v-model="formData.time_change_way"  active-value="periods" inactive-value="month" class="limit_switch" :disabled="!['enrollEdit','enrollInitiated'].includes(formData.enroll_status)" @change="changeWay"></el-switch>
              </el-form-item>
              
               <div class="flex-box" v-for="(rangeItem, rangeIndex) in formData.classRangeList" :key="rangeIndex" v-if="formData.time_change_way==='month'">
                <div class="left">
                  <el-form-item :label="`计划开班月份${rangeIndex + 1}`" :prop="`classRangeList.${rangeIndex}.classRangeListItem`" :rules="{required: true, message: '请选择开班月份区间', trigger: 'change'}">
                <el-date-picker
                  type="monthrange"
                  v-model="rangeItem.classRangeListItem"
                  :editable="false"
                  :clearable="false"
                  value-format="timestamp"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  class="input-w360"
                ></el-date-picker>
              </el-form-item>
  
                </div>
                <div class="right">
                  <el-button v-if="rangeIndex == formData.classRangeList.length - 1" type="primary" size="small" circle icon="el-icon-plus" @click="handleAddPlaneDate(rangeItem, rangeIndex)"></el-button>
                  <el-button v-if="formData.classRangeList.length > 1" type="danger" size="small" circle icon="el-icon-minus" @click="handleRemovePlaneDate(rangeItem, rangeIndex)"></el-button>
                </div>
              </div>
  
              <div class="flex-box" v-for="(rangeItem, rangeIndex) in formData.classRangeListPeriods" :key="rangeIndex" v-if="formData.time_change_way==='periods'">
                <div class="left">
                  <el-form-item :label="`计划开班期数${rangeIndex + 1}`" >
  
                    <div class="periodsClass"  style="display:block">
                      <el-form-item label="第一阶段" label-width="100px" :prop="`classRangeListPeriods.${rangeIndex}.trainRangeOne`" :rules="[requiredItem('第一阶段', true)]">
                        <!--<el-date-picker-->
                        <!--v-model="rangeItem.start_date"-->
                        <!--type="date"-->
                        <!--@focus="datePickerOfStart(rangeItem)"-->
                        <!--:picker-options="pickerOptionsStart"-->
                        <!--placeholder="选择日期"-->
                        <!--value-format="timestamp"-->
                        <!--style="width:150px"-->
                        <!--&gt;-->
                        <!--&lt;!&ndash;pickerOptionsStart&ndash;&gt;-->
                        <!--</el-date-picker>-->
      
                        <el-date-picker
                          type="daterange"
                          :editable="false"
                          :clearable="false"
                          :picker-options="trainRangeOpt"
                          value-format="timestamp"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          v-model="rangeItem.trainRangeOne"
                          class="input-w360"
                        ></el-date-picker>
                      </el-form-item>
    
                      <el-form-item label="第二阶段" label-width="100px" :prop="`classRangeListPeriods.${rangeIndex}.trainRangeTwo`" :rules="[requiredItem('第二阶段', true)]" style="margin-top:20px">
                        <el-date-picker
                          type="daterange"
                          :editable="false"
                          :clearable="false"
                          :picker-options="trainRangeOpt"
                          value-format="timestamp"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          v-model="rangeItem.trainRangeTwo"
                          class="input-w360"
                        ></el-date-picker>
    
                      </el-form-item>
                      <el-form-item label="举办地" label-width="100px" style="margin-top:20px">
                        <el-select v-model="rangeItem.province_id" placeholder="请选择省份" @change="updateCity(rangeIndex)" style="width:170px" clearable>
                          <el-option v-for="(item, index) in area_list" :key="index" :label="item.regionName" :value="item.id"></el-option>
                        </el-select>
                        <el-select v-model="rangeItem.city_id" placeholder="请选择市" style="width:170px;margin-left:20px" clearable>
                          <el-option v-for="(item, index) in rangeItem.city_list" :key="index" :label="item.regionName" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
        
        
                    <!--<el-date-picker-->
                    <!--type="monthrange"-->
                    <!--v-model="rangeItem.classRangeListItem"-->
                    <!--:picker-options="classRangeOpt"-->
                    <!--:editable="false"-->
                    <!--:clearable="false"-->
                    <!--value-format="timestamp"-->
                    <!--range-separator="至"-->
                    <!--start-placeholder="开始月份"-->
                    <!--end-placeholder="结束月份"-->
                    <!--class="input-w360"-->
                    <!--&gt;</el-date-picker>-->
                  </el-form-item>
    
                </div>
                <div class="right">
                  <el-button v-if="rangeIndex == formData.classRangeListPeriods.length - 1" type="primary" size="small" circle icon="el-icon-plus" @click="handleAddPlanePeriods(rangeItem, rangeIndex)"></el-button>
                  <el-button v-if="formData.classRangeListPeriods.length > 1" type="danger" size="small" circle icon="el-icon-minus" @click="handleRemovePlanePeriods(rangeItem, rangeIndex)"></el-button>
                </div>
              </div>
              <template v-if="formData.enroll_type !== 'continue_education' && formData.enroll_type !== 'goalkeeper_education'">
              <el-form-item label="审核截止日期" prop="recommend_end_date">
                <el-date-picker
                  type="date"
                  v-model="formData.recommend_end_date"
                  :picker-options="recommendEndDateRangeOpt"
                  :clearable="true"
                  value-format="yyyy-MM-dd"
                  class="input-w360"
                  placeholder="选择审核截止日期"
                ></el-date-picker>
              </el-form-item>
              </template>
              <template
                v-if="
                  formData.enroll_type === 'continue_education' ||
                  formData.enroll_type === 'goalkeeper_education'
                "
              >
                <el-form-item
                  label="培训方式"
                  class="inline-item-wrap"
                  required
                  prop="train_way"
                  :rules="[
                    {
                      required: true,
                      message: '请选择培训方式',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-select
                    v-model="formData.train_way"
                    :disabled="['enrollIncomplete','enrollFinalised','enrollComplete'].includes(formData.enroll_status)"
                    class="input-w260"
                    placeholder="请选择培训方式"
                  >
                    <el-option label="线上（在线视频学习）" value="online"></el-option>
                    <el-option label="线下（教案编写）" value="offline"></el-option>
                    <el-option label="线上+线下" value="online,offline"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <el-form-item label="报名人数限制" prop="numLimit" class>
                <el-switch v-model="formData.ifLimit" class="limit_switch"></el-switch>
                <el-input-number
                  v-show="formData.ifLimit"
                  v-model="formData.numLimit"
                  :disabled="!formData.ifLimit"
                  controls-position="right"
                  :min="1"
                  :step="1"
                  step-strictly
                ></el-input-number>
                <span v-show="formData.ifLimit" class="text_line right">人</span>
              </el-form-item>

              <el-form-item label="快速培训通道" class="test-inline">
                <el-radio-group v-model="formData.is_special_train">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
  
              <el-form-item label="是否需要个人体检报告" class="test-inline">
                <el-radio-group v-model="formData.is_need_physical">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是(必传)</el-radio>
                  <el-radio :label="2">是(非必传)</el-radio>
                </el-radio-group>
              </el-form-item>
  
              <el-form-item label="是否需要人身意外保险" class="test-inline">
                <el-radio-group v-model="formData.is_need_accident">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是(必传)</el-radio>
                  <el-radio :label="2">是(非必传)</el-radio>
                </el-radio-group>
              </el-form-item>
  
              <el-form-item label="是否需要在职证明" class="test-inline">
                <el-radio-group v-model="formData.is_need_jobProof">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是(必传)</el-radio>
                  <el-radio :label="2">是(非必传)</el-radio>
                </el-radio-group>
              </el-form-item>
  
              <el-form-item label="是否支持多志愿选择" class="test-inline">
                <el-radio-group v-model="formData.is_choose_classDate">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是(必选)</el-radio>
                  <el-radio :label="2">是(非必选)</el-radio>
                </el-radio-group>
              </el-form-item>
  
              <el-form-item label="是否需要无犯罪记录证明" class="test-inline">
                <el-radio-group v-model="formData.is_proof_crime">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是(必传)</el-radio>
                  <el-radio :label="2">是(非必传)</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="是否需要疫苗接种证明" class="test-inline">
                <el-radio-group v-model="formData.is_vaccine">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是(必选)</el-radio>
                  <el-radio :label="2">是(非必选)</el-radio>
                </el-radio-group>
              </el-form-item>
  
              <el-form-item label="是否需要确认免责声明" class="test-inline">
                <el-radio-group v-model="formData.is_notification">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是(必选)</el-radio>
                  <el-radio :label="2">是(非必选)</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="是否需要教练详细身份" class="test-inline">
                <el-radio-group v-model="formData.is_need_identity">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是(必选)</el-radio>
                  <el-radio :label="2">是(非必选)</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="是否需要填写现居住地" class="test-inline">
                <el-radio-group v-model="formData.is_need_live_address">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是(必选)</el-radio>
                  <el-radio :label="2">是(非必选)</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="是否需要英文简历" class="test-inline">
                <el-radio-group v-model="formData.is_need_English_resume">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是(必选)</el-radio>
                  <el-radio :label="2">是(非必选)</el-radio>
                </el-radio-group>
              </el-form-item>
  
              <el-form-item label="联系人" prop="saveContact" class="test-inline">
                <el-button type="primary" @click="ifContactDiaShow=true">添加联系人</el-button>
                <span :class="['tip', testContact ? 'yes':'no']">{{testContact?'联系人添加成功':'联系人未添加'}}</span>
              </el-form-item>

<!--              <el-form-item label="官网通知链接" prop="intro" class>-->
<!--                <el-input v-model.trim="formData.intro" class="input-w360" placeholder="请填写官网通知链接"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="说明" prop="intro" >
                <el-input v-show="false" v-model="formData.intro" class placeholder></el-input>
                <quill-editor
                        class="editor-box"
                        ref="textEditor"
                        v-model="formData.intro"
                        :options="editorOption"
                ></quill-editor>
              </el-form-item>
<!--              <el-form-item label="联系人" prop="saveContact" class="test-inline">-->
<!--                <el-button type="primary" @click="ifContactDiaShow=true">添加联系人</el-button>-->
<!--                <span :class="['tip', testContact ? 'yes':'no']">{{testContact?'联系人添加成功':'联系人未添加'}}</span>-->
<!--              </el-form-item>-->

              <el-form-item label="附件上传">
                <el-upload
                  ref="uploadFile"
                  action="/api/enroll/upload_enroll_file.json"
                  :file-list="formData.files"
                  :headers="fileUpHeaders"
                  :data="fileUpParam"
                  :before-upload="beforeUpload"
                  :on-progress="isUping"
                  :on-error="uploadError"
                  :on-success="uploadSuccess"
                  :on-remove="fileRemove"
                >
                  <el-button type="primary">点击上传</el-button>
                  <div slot="tip" class>只能上传jpg/png/pdf/xlsx/xls/docx/doc文件，且文件大小不能超过200M</div>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="post-btn">
        <el-button
          type="primary"
          :disabled="submitDisabled"
          @click="startClass(formData.enroll_status === 'enrollEdit' ? 'enrollInitiated' : formData.enroll_status)"
        >提交报名</el-button>
        <template v-if="formData.enroll_status === 'enrollEdit'">
          <el-button :disabled="submitDisabled" @click="startClass('enrollEdit')">暂时保存</el-button>
        </template>
      </div>
    </div>
    <el-dialog
      :visible.sync="ifNameDiaShow"
      :close-on-click-modal="false"
      top="13vh"
      width="450px"
      class="yi-dialog-root"
    >
      <div class="slot-dialog-header" slot="title">
        <span class="title">添加报名名称</span>
      </div>
      <div class="dialog-content name-dia-content">
        <el-form
          :model="nameData"
          :rules="nameFormRules"
          ref="nameDialogForm"
          label-width="100px"
          size="medium"
          class="dia-form"
        >
          <el-form-item label="开启自定义" prop="ifCustom" class>
            <el-switch v-model="nameData.ifCustom" class></el-switch>
          </el-form-item>

          <el-form-item v-show="nameData.ifCustom" label="自定义名称" prop="custom" class>
            <el-input
              v-model.trim="nameData.custom"
              class
              :disabled="!nameData.ifCustom"
              placeholder="请填写报名名称"
              maxlength="50"
            ></el-input>
          </el-form-item>

          <div v-show="!nameData.ifCustom">
            <el-form-item label="年份" prop="year">
              <el-date-picker
                v-model="nameData.year"
                :editable="false"
                :clearable="false"
                :picker-options="yearOpt"
                value-format="yyyy"
                type="year"
                :disabled="nameData.ifCustom"
                class="w100"
                placeholder="请选择年份"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="季度" prop="quarter" class>
              <el-select
                v-model="nameData.quarter"
                placeholder="请选择季度"
                class="w100"
                :disabled="nameData.ifCustom"
              >
                <el-option
                  v-for="item in quarterList"
                  :key="item.value"
                  :label="item.key"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="次数" prop="times" class>
              <span class="text_line left">第</span>
              <el-input-number
                v-model="nameData.times"
                controls-position="right"
                :min="1"
                :step="1"
                step-strictly
                :disabled="nameData.ifCustom"
              ></el-input-number>
              <span class="text_line right">次</span>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="footer-btn" slot="footer">
        <div class="btns">
          <el-button type="primary" @click="saveNameData">保存</el-button>
          <el-button type="danger" @click="ifNameDiaShow=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      @open="contactDiaOpen"
      :visible.sync="ifContactDiaShow"
      :close-on-click-modal="false"
      top="13vh"
      width="855px"
      class="yi-dialog-root scroll-dialog"
    >
      <div class="slot-dialog-header" slot="title">
        <span class="title">添加联系人</span>
      </div>
      <div class="dialog-content contact-dia-content">
        <vue-scroll :ops="disScrollOpt">
          <div class="dia-scroll-content">
            <el-form
              :model="contactData"
              ref="contactDialogForm"
              label-width="80px"
              size="medium"
              class="dia-form"
            >
              <div
                class="form-oneline-wrap clearfix"
                v-for="(contact, index) in contactData.contactInfoList"
                :key="contact.id"
              >
                <el-form-item
                  label="姓名"
                  :prop="'contactInfoList.' + index + '.name'"
                  :rules="{required: true, message: `不能为空`, trigger: `blur`}"
                  class="dia-input-wrap contact-name-wrap"
                >
                  <el-input placeholder="请输入联系人姓名" v-model="contact.name" class="dia-input-w160"></el-input>
                </el-form-item>
                <el-form-item
                  label="电话"
                  :prop="'contactInfoList.' + index + '.mobile_phone'"
                  :rules="{required: true, validator: (rule, value, callback) => {validatePhone(rule, value, callback)}, trigger: `blur`}"
                  class="dia-input-wrap contact-phone-wrap"
                >
                  <el-input
                    placeholder="请输入联系人手机号"
                    v-model="contact.mobile_phone"
                    class="dia-input-w160"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="邮箱"
                  :prop="'contactInfoList.' + index + '.email'"
                  :rules="{required: false, validator: (rule, value, callback) => {validateEmail(rule, value, callback)}, trigger: `blur`}"
                  class="dia-input-wrap contact-email-wrap"
                >
                  <el-input placeholder="请输入联系人邮箱" v-model="contact.email" class="dia-input-w160"></el-input>
                </el-form-item>
                <el-button
                  class="form-oneline-btn"
                  size="medium"
                  type="danger"
                  v-if="index > 0"
                  @click="delContact(index)"
                >删除</el-button>
                <el-button
                  v-else
                  class="form-oneline-btn"
                  size="medium"
                  type="primary"
                  @click="addContact"
                >添加</el-button>
              </div>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="footer-btn" slot="footer">
        <div class="btns">
          <el-button type="primary" @click="saveContactList">保存</el-button>
          <el-button type="danger" @click="ifContactDiaShow = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <yioks-tips
      :showTips="tipsFlag"
      :tips="tipMsg"
      :loading="submitLoading"
      @hideTips="hideTipsDialog"
    ></yioks-tips>
    <yioks-tips :showTips="backComfim" tips="确定放弃修改并返回吗？" @hideTips="backComfimDialog"></yioks-tips>
  </div>
</template>

<script>
import SignUpMixin from "./sign-up-minix";
import { editEnroll, echoSignUp } from "@/api/system_manager/api";

export default {
  name: "edit-sign-up",
  props: ["signId"],
  mixins: [SignUpMixin],
  created() {
    this.getSignUpInfo()
  },
  data() {
    return {
      nameData: {
        // ifCustom: true
      },
      submitLoading: false,
      tipMsg: "确定提交？",
    };
  },
  methods: {
    submit() {
      this.submitLoading = true;
      const formData = JSON.parse(JSON.stringify(this.formData));
      const { classRangeList,classRangeListPeriods,time_change_way } = this.formData;
      let MAX, MIN, rangeListAll = [], enroll_class_phase=[];
      if(time_change_way ==='month'){
        if(classRangeList.length) {
          classRangeList.forEach(item => {
            const [ start_date, end_date ] = item.classRangeListItem;
            enroll_class_phase.push({
              start_date, end_date
            })
            rangeListAll = [...rangeListAll, start_date, end_date]
          });
        } else {
          console.error('计划开班时间列表 classRangeList 有问题咯')
        }
      } else{
        if(classRangeListPeriods.length) {
          classRangeListPeriods.forEach(item => {
            const { trainRangeOne, trainRangeTwo,province_id,city_id } = item;
            const start_date = trainRangeOne[0];
            const end_date = trainRangeOne[1];
            const start_date_two = trainRangeTwo[0];
            const end_date_two = trainRangeTwo[1];
            enroll_class_phase.push({
              start_date:trainRangeOne[0],
              end_date:trainRangeOne[1],
              start_date_two:trainRangeTwo[0],
              end_date_two:trainRangeTwo[1],
              province_id:province_id,
              city_id:city_id,
            })
            rangeListAll = [...rangeListAll, start_date, end_date,start_date_two,end_date_two]
          });
        } else {
          console.error('计划开班期数 时间段有问题咯')
        }
      }
      MAX = Math.max(...rangeListAll);
      MIN = Math.min(...rangeListAll);
      const submitData = {
        enroll_uuid: this.signId,
        enroll_name: formData.sign_name,
        enroll_level: formData.class_level,
        enroll_start: formData.trainRange[0],
        enroll_end: formData.trainRange[1],

        // class_start: formData.classRange[0],
        // class_end: formData.classRange[1],
        class_start: MIN,
        class_end: MAX,
        enroll_class_phase: JSON.stringify(enroll_class_phase),

        recommend_end_date: formData.recommend_end_date,
        enroll_person_num: formData.ifLimit ? formData.numLimit : 0,
        is_speediness_train: formData.is_special_train,
        is_need_physical: formData.is_need_physical,
        is_need_accident: formData.is_need_accident,
        is_need_jobProof: formData.is_need_jobProof,
        is_choose_classDate: formData.is_choose_classDate,
        is_proof_crime: formData.is_proof_crime,
        is_notification: formData.is_notification,
        is_vaccine: formData.is_vaccine,
        is_need_identity: formData.is_need_identity,
        is_need_live_address: formData.is_need_live_address,
        is_need_English_resume: formData.is_need_English_resume,
        enroll_content: formData.intro,
        enroll_status: this.ajaxStatus,
        train_way: formData.train_way,
        time_change_way: formData.time_change_way,
        enroll_linkman: JSON.stringify(formData.saveContact),
        enroll_document: JSON.stringify(formData.files.map(item => ({
          document_url: item.url,
          document_name: item.name,
          document_id: item.document_id || '',
        })))
      }
      editEnroll(submitData).then(({ data: { status } }) => {
        this.submitLoading = false;
        if (status === 0) {
//          this.$router.push("/system/train_sign_up");
          this.$router.go(-1);
        } else {
        }
      }).catch(err => {
        this.submitLoading = false;
        console.log(err);
      });
    },
    // nameDiaClose() {
    //   this.$refs["nameDialogForm"].resetFields();
    //   // this.nameData.custom =  '';
    //   // this.nameData.ifCustom = false;
    // },
    getSignUpInfo() {
      echoSignUp({ enroll_uuid: this.signId }).then(
        ({ data: { result: {documentDate, classPhase, enrollInfo, linkmenData}, status } }) => {
          if(status === 0) {
            let classRangeList = []
            classPhase.forEach(item => {
              const {start_date, end_date} = item;
              const classRangeListItemObj = {
                classRangeListItem:[start_date, end_date]
              }
              classRangeList.push(classRangeListItemObj)
            });
            let classRangeListPeriods = []
            classPhase.forEach((item,index) => {
              const {start_date, end_date, start_date_two, end_date_two,province_id,city_id} = item;
              let city_list = [];
              if(province_id > 0){
                city_list = this.$yioks.updateCity(province_id, this.area_list)
              }
              const classRangeListItemObj = {
                trainRangeOne:[start_date, end_date],
                trainRangeTwo:[start_date_two, end_date_two],
                province_id:province_id === 0 ? '' : String(province_id),
                city_id:city_id === 0 ? '' : String(city_id),
                city_list : city_list
              }
              
              classRangeListPeriods.push(classRangeListItemObj)
            });
            this.formData.class_level = enrollInfo.enroll_level
            this.enroll_type=enrollInfo.enroll_type
            this.formData.trainRange = [enrollInfo.enroll_start, enrollInfo.enroll_end]
            // this.formData.classRange = [enrollInfo.class_start, enrollInfo.class_end]
            this.formData.classRangeList = classRangeList
            this.formData.classRangeListPeriods = classRangeListPeriods
            this.formData.recommend_end_date = enrollInfo.recommend_end_date
            this.formData.ifLimit = enrollInfo.enroll_person_num !== 0
            this.formData.numLimit = enrollInfo.enroll_person_num
            this.formData.is_special_train = !!enrollInfo.is_speediness_train ? 1:0;
            this.formData.is_need_physical = enrollInfo.is_need_physical;
            this.formData.is_need_jobProof = enrollInfo.is_need_jobProof
            this.formData.is_choose_classDate = enrollInfo.is_choose_classDate
            this.formData.is_need_accident = enrollInfo.is_need_accident;
            this.formData.is_need_identity = enrollInfo.is_need_identity;
            this.formData.is_need_live_address = enrollInfo.is_need_live_address;
            this.formData.is_need_English_resume = enrollInfo.is_need_English_resume;
            this.formData.is_proof_crime = enrollInfo.is_proof_crime;
            this.formData.is_notification = enrollInfo.is_notification;
            this.formData.is_vaccine = enrollInfo.is_vaccine;
            this.formData.intro = enrollInfo.enroll_content
            this.formData.enroll_status = enrollInfo.enroll_status
            this.formData.enroll_type = enrollInfo.enroll_type
            this.formData.train_way = enrollInfo.train_way
            this.formData.time_change_way = enrollInfo.time_change_way

            this.nameData.custom = enrollInfo.enroll_name
            // this.nameData.ifCustom = !!enrollInfo.enroll_name;
            this.formData.sign_name = enrollInfo.enroll_name

            const linkmanList = linkmenData.map(({email, name, mobile_phone, linkman_id}, index) => ({
              name,
              email,
              linkman_id,
              mobile_phone,
              id: index+1
            }));
            this.formData.saveContact = [...linkmanList];
            this.contactData.contactInfoList = JSON.parse(JSON.stringify(linkmanList));
            this.testContact = true;
            this.formData.files = documentDate.map(item => ({
              url: item.document_address,
              document_id: item.document_id,
              name: item.document_title
            }))
          }
        }
      );
    },
    // 添加计划开班月份
    handleAddPlaneDate(item, index) {
      let { classRangeList } = this.formData;
      // if(classRangeList.length >= 5) return;  // 最多添加5条计划日期
      classRangeList.push({
        classRangeListItem: [],
      });
    },
    // 添加计划开班月份
    handleAddPlanePeriods(item, index) {
      let { classRangeListPeriods } = this.formData;
      // if(classRangeList.length >= 5) return;  // 无上限
      classRangeListPeriods.push({
        trainRangeOne:[],
        trainRangeTwo:[],
        province_id:'',
        province_name:'',
        city_id:'',
        city_name:'',
      });
    },
    // 删除计划开班月份
    handleRemovePlaneDate(item, index) {
      let { classRangeList } = this.formData;
      if(classRangeList.length == 1) return;  // 至少保留一个
      classRangeList.splice(index,1)
    },
  
    // 删除计划开班月份
    handleRemovePlanePeriods(item, index) {
      let { classRangeListPeriods } = this.formData;
      if(classRangeListPeriods.length == 1) return;  // 至少保留一个
      classRangeListPeriods.splice(index,1)
    },
  }
};
</script>

<style lang="stylus">
@import './sign-up.styl'

.flex-box
  display: flex
  justify-content: flex-start
  .right
    margin-left 20px
    box-sizing: border-box
  .periodsClass
    display:flex
</style>
